module.exports = __webpack_public_path__ + "6d8b1238d4549dce1b6c9ae35f978e71.svg";